var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "gh-sidebar__body" }, [
    _vm.listLoading && !_vm.listItems.length
      ? _c("div", { staticClass: "gh-sidebar__loading" }, [
          _c("i", {
            staticClass: "fa fa-spinner fa-spin",
            attrs: { "aria-hidden": "true" },
          }),
        ])
      : _vm.listError
      ? _c("div", { staticClass: "gh-sidebar__error" }, [
          _vm._v(_vm._s(_vm.listError)),
        ])
      : !_vm.listItems.length
      ? _c("div", { staticClass: "gh-sidebar__empty" }, [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("generation_history.sZeroRecords")) +
              "\n  "
          ),
        ])
      : _c(
          "div",
          {
            ref: "listEl",
            staticClass: "gh-sidebar__list",
            on: { scroll: _vm.onListScroll },
          },
          _vm._l(_vm.listItems, function (item) {
            return _c(_vm.resolveListItemComponent(item.project_type), {
              key: item.project_id,
              tag: "component",
              attrs: { item: item },
              on: { "view-all": _vm.onViewAll },
            })
          }),
          1
        ),
    _vm._v(" "),
    _vm.listLoading && _vm.listItems.length
      ? _c("div", { staticClass: "gh-sidebar__loading-more" }, [
          _c("i", {
            staticClass: "fa fa-spinner fa-spin",
            attrs: { "aria-hidden": "true" },
          }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }